import styled, { css } from 'styled-components'
import { StyledActionButtonProps, ActionCountProps } from './ActionButton.types'

export const StyledActionButton = styled.button<StyledActionButtonProps>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};
  white-space: nowrap;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  text-decoration: none;
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: 1;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
    border-color: ${({ theme }) => theme.colors.text.tertiary};
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${(props) =>
    props.$active &&
    css`
      background: ${props.theme.colors.primaryLight};
      color: ${props.theme.colors.primary};
      border-color: ${props.theme.colors.primary};
    `}
`

export const ActionCount = styled.span<ActionCountProps>`
  font-size: 10px;
  padding: 1px 4px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  margin-left: 2px;
`

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`
